import { useState, useEffect } from 'react';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Courses', href: '/courses' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Features', href: '/features' },
    { label: 'Testimonials', href: '/testimonials' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-background-50/80 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-24">
        <Link to="/" className="flex items-center gap-2 font-bold text-xl tracking-tight text-foreground-950">
          <div className="w-20 h-20 flex items-center justify-center overflow-hidden">
            <img
              alt="ggcourse"
              className="w-full h-full object-contain"
              src="https://static.readdy.ai/image/b83b8b9a8d6ac616d68701c8b393b970/6b0747328001cf5b1e1edeec1877761c.png"
            />
          </div>
          <span className="font-heading">ggcourse</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/courses"
            className="inline-flex shrink-0 items-center justify-center text-sm font-medium whitespace-nowrap transition-all outline-none bg-foreground-900 text-background-50 hover:bg-foreground-800 h-8 gap-1.5 rounded-md px-3"
          >
            Browse Courses
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileMenuOpen ? 'close-line' : 'menu-line'} text-xl w-5 h-5 flex items-center justify-center`} />
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="block text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex flex-col gap-2 pt-2">
            <Link
              to="/courses"
              className="inline-flex shrink-0 items-center justify-center text-sm font-medium whitespace-nowrap transition-all bg-foreground-900 text-background-50 hover:bg-foreground-800 h-9 rounded-md px-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              Browse Courses
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}